import React from 'react'
import styled from '@emotion/styled'
import ContentWrapper from '@vio/atlas/helpers/ContentWrapper'
import {Flex} from '@vio/atlas/helpers/Flex'
import {NoStyleLink} from '@vio/atlas/helpers/NoStyleLink'
import {Icon, IconName} from '@vio/atlas/Icon'
import {Text} from '@vio/atlas/Text'
import {cssTheme} from '@vio/atlas/themes'

import {Brand} from '@daedalus/core/src/brand/types'
import FormattedMessageWrapper from '@daedalus/core/src/localization/components/FormattedMessage'

interface Props {
  brand: Brand
  isSingleColumn: boolean
}
export const FooterSocialSection = ({brand, isSingleColumn}: Props) => {
  return (
    <div>
      <Text variant="titleL">
        <FormattedMessageWrapper id="social" defaultMessage="Social" />
      </Text>
      <ContentWrapper paddingTop="s400">
        <Flex.Row
          gap="s300"
          justifyContent={isSingleColumn ? 'center' : 'flex-start'}
        >
          <FooterSocialButton
            url={brand.socials?.instagramUrl}
            iconName="Instagram"
          />
          <FooterSocialButton
            url={brand.socials?.facebookUrl}
            iconName="Facebook"
          />
          <FooterSocialButton
            url={brand.socials?.linkedinUrl}
            iconName="Linkedin"
          />
        </Flex.Row>
      </ContentWrapper>
    </div>
  )
}

interface FooterSocialButtonProps {
  url?: string
  iconName: IconName
}
const FooterSocialButton = ({url, iconName}: FooterSocialButtonProps) => {
  if (!url) {
    return null
  }
  return (
    <SocialLink href={url} target="_blank">
      <Icon name={iconName} size="lg" colorPath={'content.neutral.c950'} />
    </SocialLink>
  )
}

const SocialLink = styled(NoStyleLink)`
  height: ${cssTheme.layout.spacing.s800};
  width: ${cssTheme.layout.spacing.s800};
  border-radius: 50%;
  background-color: ${cssTheme.colors.background.neutral.c000};
  display: flex;
  justify-content: center;
  align-items: center;
`
